import { useState } from "react";
import ModalLayout from "./shared-components/Layout/ModalLayout";

const AutomaticLogout = ({ children }) => {
  // let timer;
  const [stage, setStage] = useState(0);
  //Automatic log out user after being inactive for 2 minutes
  // TODO: COME BACK TO THIS
  // useEffect(() => {
  //   let timeout;
  //   const resetTimeout = () => {
  //     if (timeout) clearTimeout(timeout);
  //     timeout = setTimeout(() => {
  //       setStage(1);
  //       setTimeout(() => {
  //         if (stage === 1) {
  //           logoutAction();
  //         } else {
  //           return;
  //         }
  //       }, 15000);
  //     }, 120000);
  //   };

  //   const handleUserActivity = () => {
  //     resetTimeout();
  //   };

  //   window.addEventListener("mousemove", handleUserActivity);
  //   window.addEventListener("keydown", handleUserActivity);
  //   window.addEventListener("click", handleUserActivity);
  //   window.addEventListener("scroll", handleUserActivity);
  //   window.addEventListener("keypress", handleUserActivity);
  //   window.addEventListener("load", handleUserActivity);
  //   window.addEventListener("mousedown", handleUserActivity);
  //   resetTimeout();

  //   return () => {
  //     window.removeEventListener("mousemove", handleUserActivity);
  //     window.removeEventListener("keydown", handleUserActivity);
  //     window.addEventListener("click", handleUserActivity);
  //     window.addEventListener("scroll", handleUserActivity);
  //     window.addEventListener("keypress", handleUserActivity);
  //     window.addEventListener("load", handleUserActivity);
  //     window.addEventListener("mousedown", handleUserActivity);
  //     clearTimeout(timeout);
  //   };
  // }, [stage]);

  const logoutAction = () => {
    if (stage === 1) {
      localStorage.clear();
      localStorage.setItem("firstTime", "true");
      window.location.pathname = "/";
    }
    return;
  };

  return (
    <div>
      <ModalLayout
        show={stage === 1}
        close={() => false}
        btnText="LOG OUT"
        showCancel={true}
        setStage={setStage}
        onClick={logoutAction}
      >
        <div className="flex justify-center items-center flex-col">
          <h1 className="text-2xl BoldFonter mb-5 text-hervestPink">
            Automatic Logout
          </h1>
          <p>You are about to be logged out due to inactivity</p>
        </div>
      </ModalLayout>
      {children}
    </div>
  );
};

export default AutomaticLogout;
